import { ReturnSummaryTotalsSchema } from "@redotech/redo-return-core-common/returns/return-totals/types";
import * as z from "zod";

export const getReturnTotals = {
  name: "getReturnTotals" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({ returnSummaryTotals: ReturnSummaryTotalsSchema }),
};
